import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allClients } from 'app/mocks/data/park/clients'
import { allPermissions } from 'app/mocks/data/users/profiles/permissions'

import { api } from 'app/utils/constants'

import { Profile, ProfilePayload } from 'app/types/users/profile'

export const createProfile = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.users.profiles.LIST}`,
    async ({ request }) => {
        const payload = await request.json()
        const payloadParsed = ProfilePayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(payloadParsed.error.issues, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json<Profile>(
            {
                id: 999,
                ...payloadParsed.data,
                client: allClients.find(
                    (client) => client.id === payloadParsed.data.client,
                ),
                permissions: allPermissions.filter((permission) =>
                    payloadParsed.data.permissions.includes(permission.id),
                ),
            },
            {
                status: StatusCodes.CREATED,
            },
        )
    },
)
